module.exports = __webpack_public_path__ + "static/media/9@1920w.c5594ce2.jpg";